import { useEffect, useState } from 'react'
import { getMencionables } from '../../api/client'

// Who can be mentioned with @, asked once for the whole session and shared by every comment box.
let cache = null
let pendiente = null

function cargar() {
  if (!pendiente) {
    pendiente = getMencionables().then(l => { cache = Array.isArray(l) ? l : []; return cache }).catch(() => { pendiente = null; return [] })
  }
  return pendiente
}

export function useMencionables() {
  const [lista, setLista] = useState(cache || [])
  useEffect(() => {
    let vivo = true
    cargar().then(l => { if (vivo) setLista(l) })
    return () => { vivo = false }
  }, [])
  return lista
}

export { aHandle, variantes } from './handles'
